import React from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Blog from "../components/Sections/Blog";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"
import FAQs from "../components/Sections/FAQs"
import { Helmet } from "react-helmet";
import Editions from "../components/Sections/Edition";
import AboutChamaFlow from "../components/Sections/AboutChamaFlow";
import FeaturesSection from "../components/Sections/Features";
import PricingSection from "../components/Sections/Pricings";
import RequestDemoPage from "./RequestDemoPage";
import WhyChooseChamaFlow from "../components/Sections/WhyChooseChamaflow";
import DemoImageSection from "../components/Sections/DemoImagesSection";



export default function Landing() {
  return (
    <>
    <Helmet>
                <title>ChamaFlow</title>
                <meta name="description" content="ChamaFlow is a Desktop app for managing Chamas and micro-finances, tailored for small businesses in Africa. Core features:"/>
                <link rel='canonical' href='/'/>

              
            </Helmet>
     <TopNavbar />
      <Header /> 
      <AboutChamaFlow/>
      <WhyChooseChamaFlow/>
      <DemoImageSection/>
      <FeaturesSection/>
      <Editions/>
      <PricingSection/>      
      <RequestDemoPage/>   
    
      <FAQs/>
   
      {/*<Blog />*/}
      <Contact />
      <Footer />
    </>
  );
}


